import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { Box, Typography, type SwitchProps as MuiSwitchProps, Tooltip, Switch as MuiSwitch } from '@mui/material'
import { forwardRef, type ForwardedRef } from 'react'
import { AsteriskRed } from '../AsteriskRed/AsteriskRed'

export interface SwitchProps extends Omit<MuiSwitchProps, 'value'> {
  required?: boolean
  label?: string
  noTitle?: boolean
  tooltipText?: string
}

export const Switch = forwardRef(function Switch(
  { label, required, noTitle, tooltipText, ...props }: SwitchProps,
  ref: ForwardedRef<unknown> | undefined,
) {
  return (
    <Box>
      {!noTitle && (
        <Box>
          <Typography>
            {label || <>&nbsp;</>}
            {required && <AsteriskRed />}
            <>&nbsp;</>
            {tooltipText && (
              <Tooltip title={tooltipText}>
                <HelpOutlineOutlinedIcon fontSize="small" />
              </Tooltip>
            )}
          </Typography>
        </Box>
      )}
      <MuiSwitch
        inputRef={ref}
        size="small"
        {...props}
      />
    </Box>
  )
})
